import { render, staticRenderFns } from "./InventTable.vue?vue&type=template&id=48b881f6"
import script from "./InventTable.vue?vue&type=script&lang=js"
export * from "./InventTable.vue?vue&type=script&lang=js"
import style0 from "./InventTable.vue?vue&type=style&index=0&id=48b881f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports